import axios from 'axios'
import API from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/facturas/series`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(serie) {
    return apiClient.post(`${serie.id}`, serie)
  },

  cancelar(idSerie) {
    return apiClient.post(`${idSerie}/cancelar`)
  },

  eliminar(idSerie) {
    return apiClient.delete(`${idSerie}`)
  },

  guardar(serie) {
    return apiClient.post('', serie)
  },

  serieJSON(idSerie) {
    return apiClient.get(`${idSerie}.json`)
  },

  seriesJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/facturas/series.json`, { params: params })
  }
}
